import { Axios } from '@src/app/context/Api/includes/Axios';
import { _translateCriteriaFilters } from '@src/entities/ActionPath/includes/functions';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isNil, omit } from 'lodash';

/**
 * SaveCommonCriteria
 *
 * Saves a set of common criteria filter with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveCommonCriteria = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/criteria',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    let criteria = [];

    if (!isNil(thePayload?.filters)) {
      criteria = _translateCriteriaFilters(thePayload?.filters, 'outgoing');
    }

    if (thePayload?.action === 'saveName') {
      requestArgs.method = 'PUT';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.id}`;
      requestArgs.data = omit(thePayload, ['filters', 'action']);
    }

    if (thePayload?.action === 'createVersion') {
      requestArgs.method = 'POST';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.id}/version`;
      requestArgs.data = { criteria };
    }

    if (['activate', 'deactivate', 'update'].includes(thePayload?.action)) {
      requestArgs.method = 'PUT';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.id}`;
      requestArgs.data = omit(thePayload, ['action', 'filters', 'version']);
    }

    if (thePayload?.action === 'update') {
      requestArgs.data.activeCommonCriteriaVersion = { criteria };
      requestArgs.data.activeVersionNbr = thePayload?.version;
    }

    if (thePayload?.action === 'create') {
      requestArgs.data = omit(thePayload, ['id', 'filters', 'action']);
      requestArgs.data.criteria = criteria;
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Criteria/api/requests/mutations/SaveCommonCriteria.js -> SaveCommonCriteria()',
      false,
      error
    );

    throw error;
  }
};
